export default __webpack_public_path__ + "static/335-628399d0c5eb3af85c2fd28758b46cd3.gif";